<div class="row">
    <div class="col-12" style="margin-top: 100px;">

    </div>
</div>

<section class="">
    <div class="container-xl">
        <div class="row mt-2 justify-content-center">
            <h3 class="custom-text text-center">
                50% off
            </h3>
            <h2 class="text-center dark mb-3 underline">
                Owner Plan
            </h2>
            <div class="col-md-4 card-fit">
                <div class="card">
                    <div class="card-header card-header-first">
                        <div class="row mt-3">
                            <div class="col-8">
                                <p>Standard Plan</p>
                            </div>
                            <div class="col-4">
                                <p class="text">AED <span class="dash-line">475</span> 237.5</p>
                                <!-- <p class="word">+5% VAT</p> -->
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-10">
                                <p class="bold list">Plan validity</p>
                            </div>
                            <div class="col-2 text-end">
                                <p class="bold list">30 Days</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10">
                                <p class="bold list">Relationship manager assistance</p>
                            </div>
                            <div class="col-2 text-end">
                                <i class="fa fa-check icon"></i>
                            </div>
                        </div>
                        <div class="text-center">
                            <button type="button" class="btn subscribe" (click)="onSubmit('1')">Subscribe</button>
                        </div>                        
                    </div>
                </div>
            </div>
            <div class="col-md-4 card-fit mb-5">
                <div class="card">
                    <div class="card-header head">
                        <div class="row mt-3">
                            <div class="col-8">
                                <p>Premium Plan</p>
                            </div>
                            <div class="col-4">
                                <p class="text">AED <span class="dash-line">875</span> 437.5</p>
                                <!-- <p class="word">+5% VAT</p> -->
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-10">
                                <p class="bold list">Plan validity</p>
                            </div>
                            <div class="col-2 text-end">
                                <p class="bold list">60 Days</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10">
                                <p class="bold list">Show property on your behalf </p>
                            </div>
                            <div class="col-2 text-end">
                                <i class="fa fa-check icon"></i>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10">
                                <p class="bold list">Photoshoot</p>
                            </div>
                            <div class="col-2 text-end">
                                <i class="fa fa-check icon"></i>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10">
                                <p class="bold list">Dedicated relationship manager</p>
                            </div>
                            <div class="col-2 text-end">
                                <i class="fa fa-check icon"></i>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10">
                                <p class="bold list">Choice to share your contact number with tenant (end to end service by direkt Team)</p>
                            </div>
                            <div class="col-2 text-end">
                                <i class="fa fa-check icon"></i>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10">
                                <p class="bold list">Documentation(standard govt charges apply)</p>
                            </div>
                            <div class="col-2 text-end">
                                <i class="fa fa-check icon"></i>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10">
                                <p class="bold list">Instant property alerts on SMS/whatsapp</p>
                            </div>
                            <div class="col-2 text-end">
                                <i class="fa fa-check icon"></i>
                            </div>
                        </div>
                        <div class="text-center">
                            <button type="button" class="btn subscribe-select" (click)="onSubmit('2')">Subscribe</button>
                        </div>                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

